// ========================================================================
// 📁 hooks/useTaskActions.js
// Purpose: A custom hook to encapsulate all business logic and API interactions.
// This cleans up the main component and makes logic reusable.
// ========================================================================

import toast from "react-hot-toast";
import axios from "axios";
import {API_BASE_URL, USER_TOKEN} from "./constants";

export const useTaskActions = (taskId, onDataRefresh) => {
    const apiRequest = async (method, endpoint, data) => {
        try {
            const response = await axios({
                method,
                url: `${API_BASE_URL}${endpoint}`,
                data,
                headers: { authorization: USER_TOKEN },
            });
            onDataRefresh(); // Refresh data on success
            return response.data;
        } catch (error) {
            console.error(`API Error on ${method} ${endpoint}:`, error);
            throw error; // Re-throw to be caught by the caller
        }
    };

    const approveOrDenyJob = async (jobId, isBefore, isApproved, details) => {
        const stage = isBefore ? 'before' : 'after';
        const endpoint = `/task/${taskId}/job/${stage}/approve`;
        const payload = { jobId: [jobId], approved: isApproved, ...details };

        try {
            await apiRequest('put', endpoint, payload);
            toast.success(`Job ${stage} state updated!`);
        } catch {
            toast.error(`Failed to update job ${stage} state.`);
        }
    };

    const updateTaskDetails = async (details) => {
        try {
            await apiRequest('put', `/task/${taskId}/update`, details);
            toast.success('Task details updated!');
        } catch {
            toast.error('Failed to update task details.');
        }
    };

    const updateReceeBrand = async (jobId, brand) => {
        try {
            await apiRequest('put', `/task/${taskId}/job/${jobId}`, { brand });
            toast.success('Task details updated!');
        } catch {
            toast.error('Failed to update task details.');
        }
    };

    return { approveOrDenyJob, updateTaskDetails, updateReceeBrand };
};
